import { useEffect } from "react"

import type { Har } from "./har"
import sampleUrl from "./sample.json?url"

export function useSampleData(
  setHar: React.Dispatch<React.SetStateAction<Har | undefined>>
) {
  useEffect(() => {
    if (process.env.NODE_ENV === "development") {
      void (async () => {
        const _har: Har = await fetch(sampleUrl).then(r => r.json())
        const { default: samples } = await import("./har-examples")
        const getEntries = (key: keyof typeof samples) => samples[key].log.entries

        setHar({
          log: {
            ..._har.log,
            entries: [
              ...getEntries("application-form-encoded"),
              ...getEntries("application-json"),
              ...getEntries("application-zip"),
              ...getEntries("cookies"),
              ...getEntries("full"),
              ...getEntries("headers"),
              ...getEntries("https"),
              ...getEntries("image-png-no-filename"),
              ...getEntries("image-png"),
              ...getEntries("jsonObj-multiline"),
              ...getEntries("jsonObj-null-value"),
              ...getEntries("multipart-data-dataurl"),
              ...getEntries("multipart-data"),
              ...getEntries("multipart-file"),
              ...getEntries("multipart-form-data"),
              ...getEntries("query-encoded"),
              ...getEntries("query"),
              ...getEntries("short"),
              ...getEntries("text-plain"),
              ...getEntries("xml"),
              ..._har.log.entries,
            ],
          },
        })
      })()
    }
  }, [setHar])
}
